import React from 'react'
import { useSelector, useDispatch } from 'hooks'
import Button from 'components/Button'
import { T } from 'components/Translations'

import { setFilters } from 'store/actions'
import { NORMAL_USER_TYPES, SPECIAL_USER_TYPES } from 'common/constants'
import StyledFilters, { StyledFilter } from './StyledFilters'

const Filter = ({ filters, name, toggleFilter }) => {
  const active = filters.includes(name)
  const special = SPECIAL_USER_TYPES.includes(name)
  const onClick = () => (!active || filters.length > 1) && toggleFilter(name, special, active)

  return (
    <StyledFilter active={active} special={special} key={name}>
      <Button size="base" color="highlight" onClick={onClick} fill={active ? 'filled' : 'transparent'}>
        {active && filters.length > 1 && <div className="deactivate" />}
        <T label={`filters/${name.replace('friends', 'hot')}`} />
      </Button>
    </StyledFilter>
  )
}

const Filters = () => {
  const filters = useSelector(s => s.router.location.query.filters?.split(',')) || ['new', 'online']
  const dispatch = useDispatch()

  const toggleFilter = (name, special, active) => {
    if (!special) {
      dispatch(setFilters(NORMAL_USER_TYPES.filter(e => filters.includes(e) ^ (e === name))))
    } else if (!active) {
      dispatch(setFilters([name]))
    }
  }

  return (
    <StyledFilters>
      {NORMAL_USER_TYPES.concat(SPECIAL_USER_TYPES).map(name => (
        <Filter key={name} name={name} filters={filters} toggleFilter={toggleFilter} />
      ))}
    </StyledFilters>
  )
}

export default Filters
